(function () {

    class GoogleTagManagerTracking {
        initialize(settings) {

            console.log(`GoogleTagManagerTracking initializing with UAID: ${settings.UAID}`)
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', settings.UAID);
            return Promise.resolve();
        }
        track(event, data) {

            var route = null;

            // External links.. har ikke en route vi kan lave smuk, men derimod en url.. 
            if (event === touchKit.TrackingManager.events.CONTENT_CLICKED && data.type === "externalLink") {
                route = data.data.url;
            } else {

                // page visits  har routes vi kan gære smukke
                route = touchKit.PageManager.breadCrumbsTitle(data.route);

                // Content Har merer data vi kan gøre smukt *K*
                if (event === touchKit.TrackingManager.events.CONTENT_CLICKED) {
                    route += `/${data.type}/${data.id}`;
                }
            }

            var preroute = window.location.href.split("scene/");

            /* DISABLED TRACKING BECAUSE THEY REMOVED THE SITEIMPROVE ACCOUNT
            _sz.push(["trackdynamic", {
                "url": preroute[0] + "scene" + data.route,
                "ref": preroute[0] + "scene/" + route,
                "title": route.split("/").pop()
            }]); */

            // Specific tracking for Karriere i KL using Talenttech
            window.ontame("pageview")
        }
    }

    touchKit.TrackingManager.registerStrategy("GoogleTagManagerTracking", () => {
        return new GoogleTagManagerTracking();
    })
}())